<ng-template #sidebarTemplate>
    <!--<button mat-icon-button class="go-back" (click)="close()">-->
    <!--<mat-icon>arrow_back</mat-icon>-->
    <!--</button>-->
    <ig-row class="login-with-fb">
        <ig-col [xs]="6">
            <span>PLACES</span>
        </ig-col>
        <ig-col [xs]="6">
            <ig-fb-login-btn #loginWithFBBtn
                             (onLoginStatusChanged)="$event && getFacebookPlaceFeed()"></ig-fb-login-btn>
        </ig-col>
    </ig-row>

    <div class="top-btn-group" *ngIf="!simpleMenu">
        <ig-row>
            <ig-col [xs]="6" *ngIf="isEventEnabled">
                <ig-button class="event-btn" (trigger)="gotoEventCalendar()">EVENTS</ig-button>
            </ig-col>

            <ig-col [xs]="isEventEnabled?6:12">
                <ig-button class="place-btn" (trigger)="gotoPlaceCalendar()">PLACES</ig-button>
            </ig-col>
        </ig-row>
    </div>

    <div class="back-to-list">
        <span (click)="gotoPlaceCalendar()">GO BACK TO PLACE LIST</span>
    </div>

    <p class="place-title">{{place?.title}}</p>
    <ng-container *ngIf="place.hostLink">
        <p class="place-host">Listed via
            <a target="_blank" href="{{place?.hostLink}}">Facebook</a>
        </p>
    </ng-container>

    <div class="img-wrap">
        <!--<img [src]="imageService.safeImage(imageService.imageSource(place))" alt="place image">-->
        <ig-image [imageUrl]="place.cover?.source" [placeCategoryList]="place.categoryList"></ig-image>
    </div>

    <div class="place-info">
        <ig-row>
            <ig-col [xs]="1">
                <mat-icon>list</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <span>{{place?.category}}</span>
            </ig-col>
        </ig-row>

        <ig-row>
            <ig-col [xs]="1">
                <mat-icon>room</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <span>{{place?.address?.address||place.address}}</span>
            </ig-col>
        </ig-row>

        <ig-row *ngIf="place?.website">
            <ig-col [xs]="1">
                <mat-icon>web</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <a target="_blank" href="{{place?.website.split(' ')[0]}}" style="word-break:break-all">{{place?.website}}</a>
            </ig-col>
        </ig-row>

        <ig-row *ngIf="place?.phone">
            <ig-col [xs]="1">
                <mat-icon>phone</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <span>{{place?.phone}}</span>
            </ig-col>
        </ig-row>

        <ig-row *ngIf="place?.emails">
            <ig-col [xs]="1">
                <mat-icon>email</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <span>{{place?.emails}}</span>
            </ig-col>
        </ig-row>

        <ig-row *ngIf="place?.priceRange">
            <ig-col [xs]="1">
                <mat-icon>attach_money</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <span>{{place?.priceRange}}</span>
            </ig-col>
        </ig-row>

        <ig-row>
            <ig-col [xs]="1">
                <mat-icon>thumb_up</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <span>{{place?.checkins}} Checkins</span>
            </ig-col>
        </ig-row>
    </div>

    <ig-row class="first-btn-row">
        <ig-col [xs]="6">
            <ig-button size="md" class="dark-blue-btn"
                       (trigger)="shareEventToFacebook()">
                SHARE
            </ig-button>
        </ig-col>
        <ig-col [xs]="6">
            <ig-button size="md" class="red-btn" (trigger)="getDirectionToEventAddress()">GET DIRECTION</ig-button>
        </ig-col>
    </ig-row>
    <ig-row class="second-btn-row">
        <ig-col [xs]="6">
            <ig-button class="ig-blue-btn" size="md"
                       (trigger)="tweetEvent()">TWEET
            </ig-button>
        </ig-col>
        <ig-col [xs]="6">
            <ig-button class="orange-btn" size="md"
                       (trigger)="mailEvent()">EMAIL
            </ig-button>
        </ig-col>
    </ig-row>

    <div class="long-btn-wrap">
        <div *ngIf="!isMobile" class="long-btn place-btn">
            <ig-button (trigger)="showMorePlaces()" [size]="'md'">Show More Places Near Here</ig-button>
        </div>

        <div *ngIf="!isFacebookLoggedIn" class="long-btn dark-blue-btn m-t-1">
            <ig-button (trigger)="loginWithFBBtn.login()" [size]="'md'">View Facebook Posts</ig-button>
        </div>
    </div>

    <div *ngIf="place?.description" class="place-details-text">
        <hr/>
        <p>PLACE DETAILS</p>

        <div class="description">
            {{place?.description}}
        </div>
    </div>

    <!--<div class="place-details-text">-->
        <!--<hr/>-->
        <!--<p>FEEDS</p>-->

        <!--<div class="feed-sign-in-reminder"-->
             <!--*ngIf="!loginWithFBBtn.isUserLoggedIn"-->
             <!--(click)="loginWithFBBtn.login()">-->
            <!--Sign In To See Feeds-->
        <!--</div>-->
        <!--<div class="facebook-posts" *ngIf="loginWithFBBtn.isUserLoggedIn">-->
            <!--<ig-facebook-post *ngFor="let post of placeFeeds"-->
                              <!--[post]="post">-->
            <!--</ig-facebook-post>-->
        <!--</div>-->
        <!--<ig-button *ngIf="placeFeedPaging"-->
                   <!--[isAsync]="true"-->
                   <!--size="md"-->
                   <!--(trigger)="getNextFacebookPlaceFeed($event)">-->
            <!--Load More-->
        <!--</ig-button>-->
    <!--</div>-->
</ng-template>

<div class="place-details">
    <div class="full-height">
        <ig-row class="full-height">
            <ig-col class="side-detail" [md]="3" [xs]="12">
                <ng-container [ngTemplateOutlet]="sidebarTemplate"></ng-container>
            </ig-col>
            <ig-col *ngIf="placeFeeds&&placeFeeds.length" class="side-detail" [md]="3" [xs]="12">
                <div class="place-feed-wrap">
                    <!--<p>FEEDS</p>-->
                    <div class="fb-post-title">
                        <img [src]="facebookLogo" alt="">
                        FACEBOOK POSTS
                    </div>
                    <!--<div class="facebook-posts" *ngIf="isFacebookLoggedIn">-->
                    <div class="facebook-posts">
                        <ig-facebook-post *ngFor="let post of placeFeeds"
                                          [post]="post">
                        </ig-facebook-post>
                    </div>
                    <ig-button *ngIf="placeFeedPaging"
                               [isAsync]="true"
                               size="md"
                               (trigger)="getNextFacebookPlaceFeed($event)">
                        Load More
                    </ig-button>
                </div>
            </ig-col>
            <ig-col class="full-height" *ngIf="!isMobile"
                    [md]="(placeFeeds&&placeFeeds.length)?6:9" [xs]="12">
                <agm-map [styles]="hideIconMapStyler" [fitBounds]="latLngBounds" [latitude]="place?.lat||lat"
                         [longitude]="place?.lng||lng"
                         [zoom]="mapZoom">
                    <agm-marker *ngIf="place?.lat&&place?.lng" [latitude]="place?.lat" [longitude]="place?.lng">
                        <agm-snazzy-info-window [isOpen]="true" [closeWhenOthersOpen]="false">
                            <ng-template>
                                <div class="map-place-title">
                                    {{place?.title}}
                                </div>
                                <div class="map-place-img">
                                    <!--<img [src]="imageService.safeImage(imageService.imageSource(place))"-->
                                         <!--alt="place image">-->
                                    <ig-image [imageUrl]="place.cover?.source" [placeCategoryList]="place.categoryList"></ig-image>
                                </div>
                                <div class="map-place-time">
                                    <p>{{place?.category}}</p>
                                </div>
                                <ig-button class="red-btn" (trigger)="getDirectionToPlaceAddress()">
                                    GET DIRECTION
                                </ig-button>
                            </ng-template>
                        </agm-snazzy-info-window>
                    </agm-marker>


                    <agm-marker *ngFor="let geo of places" #marker [latitude]="geo.lat" [longitude]="geo.lng"
                                (mouseOver)="showInfoWindow(infoWindow)"
                                (mouseOut)="hideInfoWindow(infoWindow)">
                        <agm-snazzy-info-window #infoWindow [isOpen]="false" [closeWhenOthersOpen]="true"
                                                (onmouseenter)="showInfoWindow(infoWindow)">
                            <ng-template>
                                <div class="map-place-title">
                                    {{geo.title}}
                                </div>
                                <div class="map-place-img">
                                    <!--<img [src]="imageService.safeImage(imageService.imageSource(geo))"-->
                                         <!--alt="place image">-->
                                    <ig-image [imageUrl]="geo.cover?.source" [placeCategoryList]="geo.categoryList"></ig-image>
                                </div>
                                <div class="map-place-time">
                                    <p>{{geo.category}}</p>
                                </div>
                                <ig-button class="place-btn" (trigger)="gotoDetails(geo._id)">DETAILS
                                </ig-button>
                            </ng-template>
                        </agm-snazzy-info-window>
                    </agm-marker>
                </agm-map>
            </ig-col>
        </ig-row>
    </div>
</div>

<ig-page-spinner #loadingSpinner></ig-page-spinner>



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/place.details/visitor.place.details.component.html